module.exports = __webpack_public_path__ + "img/appstore.0355e7cf.png";